import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_M",
  "use": "icon-icon_M-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-icon_M\">\n<title>路径备份</title>\n<desc>Created with Sketch.</desc>\n<path class=\"st0\" d=\"M13,0.5h-0.5L8,5L3.5,0.5H3c-1.2,0-2.5,1-2.5,2.7v12.3h2.3V3.2c0,0,0,0,0-0.1L8,8.3l5.2-5.1c0,0,0,0,0,0.1v12.3\n\th2.3V3.2C15.5,1.5,14.2,0.5,13,0.5z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol